// extracted by css-extract-rspack-plugin
export default {"root":"hwlOE7","prefix":"siGApE","input":"ehiKjV","title":"gf3ici","actions":"oxGJ4b","app-data":"MMiIDY","appData":"MMiIDY"};